import React, { useEffect, useState } from 'react';

import Modals from '@components/Modals';
import BlockEventSingle from '@components/block-event-single';
import { useBlockEventSinglePanelStore } from '@components/block-event-single/store';
import DataTransformPanel from '@components/data-transform-panel';
import { useDataTransformPanelStore } from '@components/data-transform-panel/store';
import { DimensionPanel } from '@components/dimensions';
import MappingPanel from '@components/mapping-panel';
import { useMappingPanelStore } from '@components/mapping-panel/store';
import NavigationBar from '@components/navigation-bar';
import { SummaryContainer } from '@components/summary-panel';
import ModalContext from '@src/context';
import CustomDimensionPanel from '@src/emp-3.0/components/custom-dimension/custom-dimension-panel';
import { useCustomDimensionPanelStore } from '@src/emp-3.0/components/custom-dimension/custom-dimension-panel/store';
import MappingEntrance from '@src/pages/main/components/MappingEntrance';

import { NavigationRow, TopContent } from './styled';
import { trackPageLoadTime } from '@src/sensor';
import { useInitialInfoStore } from '@src/emp-3.0/store/useInitialInfo';

const Index: React.FC<{}> = () => {
  const updateModalContext = (modalSourceElement, sourceComponent, actionArgs) => {
    setModalContextVal({
      ...modalContextVal,
      modalSourceElement,
      sourceComponent,
      actionArgs,
    });
  };
  const [modalContextVal, setModalContextVal] = useState({
    modalSourceElement: null,
    sourceComponent: '',
    actionArgs: [],
    setModalContext: updateModalContext,
  });
  const [mappingPanelOpen] = useMappingPanelStore((state) => [state.mappingPanelOpen]);
  const [transformPanelOpen] = useDataTransformPanelStore((state) => [state.transformPanelOpen]);
  const [blockEventSingleOpen] = useBlockEventSinglePanelStore((state) => [
    state.blockEventSingleOpen,
  ]);
  const { customDimensionPanelOpen } = useCustomDimensionPanelStore((state) => state);
  const { empCalenderBoundry } = useInitialInfoStore();

  useEffect(() => {
    trackPageLoadTime('Semantic Mapper');
  }, []);

  return (
    <ModalContext.Provider value={modalContextVal}>
      <TopContent>
        <NavigationRow>
          <NavigationBar />
        </NavigationRow>
        <SummaryContainer calenderBoundry={empCalenderBoundry} isSharing={false} />
        {!mappingPanelOpen &&
          !transformPanelOpen &&
          !blockEventSingleOpen &&
          !customDimensionPanelOpen && <MappingEntrance />}
      </TopContent>
      {mappingPanelOpen && (
        <div style={{ marginBottom: '8px' }}>
          <MappingPanel />
        </div>
      )}
      {transformPanelOpen && (
        <div style={{ marginBottom: '8px' }}>
          <DataTransformPanel />
        </div>
      )}
      {blockEventSingleOpen && (
        <div style={{ marginBottom: '8px' }}>
          <BlockEventSingle />
        </div>
      )}
      {customDimensionPanelOpen && (
        <div style={{ marginBottom: '8px' }}>
          <CustomDimensionPanel />
        </div>
      )}
      <DimensionPanel />
      <Modals />
    </ModalContext.Provider>
  );
};

export default Index;
